import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'aedNumber',
  standalone: true,
})
export class AedNumberPipe implements PipeTransform {
  transform(value: number | string | null | undefined, decimals: number = 0): string {
    if (value === null || value === undefined || value === '') return '0';
    const num = typeof value === 'string' ? Number(value) : value;
    if (isNaN(num)) return '0';

    return num.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }
}
